var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconClip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon--clip",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2815_4309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 7.00042V17.3994C16 19.0694 14.871 20.5894 13.235 20.9244C10.986 21.3854 9 19.6704 9 17.5004V5.11342C9 4.11742 9.678 3.19142 10.661 3.02842C11.913 2.82142 13 3.78642 13 5.00042V15.5004C13 15.7764 12.775 16.0004 12.5 16.0004C12.225 16.0004 12 15.7764 12 15.5004V7.00042C12 6.44842 11.552 6.00042 11 6.00042C10.448 6.00042 10 6.44842 10 7.00042V15.3534C10 16.6614 10.939 17.8554 12.24 17.9874C13.735 18.1394 15 16.9644 15 15.5004V5.17842C15 3.09042 13.477 1.22242 11.399 1.02042C9.014 0.788419 7 2.66342 7 5.00042V17.2554C7 20.1264 9.093 22.6944 11.949 22.9734C15.228 23.2944 18 20.7144 18 17.5004V7.00042C18 6.44842 17.552 6.00042 17 6.00042C16.448 6.00042 16 6.44842 16 7.00042H16Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2815_4309"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClip);
export default __webpack_public_path__ + "static/media/icon--clip.8ab436f695bee7ca81859b91e44c5e72.svg";
export { ForwardRef as ReactComponent };